import { fontTypes } from './ascendFonts'

// Font weight map
const fontWeightToTailwind = {
  regular: 'font-normal',
  medium: 'font-medium',
  bold: 'font-bold',
}

// Line height map
const lineHeightMap = {
  '120%': 'leading-[120%]',
  '130%': 'leading-[130%]',
  '140%': 'leading-[140%]',
}

// Font size map
const fontSizeMap = {
  3: 'text-[3rem]',
  2.5: 'text-[2.5rem]',
  2.25: 'text-[2.25rem]',
  2: 'text-[2rem]',
  1.75: 'text-[1.75rem]',
  1.5: 'text-[1.5rem]',
  1.25: 'text-[1.25rem]',
  1.125: 'text-[1.125rem]',
  1: 'text-base',
  0.875: 'text-sm',
  0.75: 'text-xs',
}

// Letter spacing map
const letterSpacingMap = {
  '0.25em': 'tracking-[0.25em]',
  '0.023em': 'tracking-[0.023em]',
  '0.018em': 'tracking-[0.018em]',
  '-0.01em': 'tracking-[-0.01em]',
}

// Mapping utilities
const fontSizeToTailwind = (size) => {
  if (typeof size === 'string' && size.endsWith('rem')) {
    const rem = parseFloat(size)
    return fontSizeMap[rem] ?? `text-[${size}]`
  }
  return ''
}

const lineHeightToTailwind = (lh) => lineHeightMap[lh] ?? ''
const letterSpacingToTailwind = (ls) => letterSpacingMap[ls] ?? (ls ? `tracking-[${ls}]` : '')

// Create tailwind class string for a font style
function createFont(fontSize, lineHeight, fontWeight, letterSpacing, desktop = false) {
  const prefix = desktop ? 'lg:' : ''

  const classes = [
    fontSizeToTailwind(fontSize),
    lineHeightToTailwind(lineHeight),
    fontWeightToTailwind[fontWeight],
    letterSpacingToTailwind(letterSpacing),
    'mb-0',
    'mt-0',
  ]
    .filter(Boolean)
    .map((cls) => `${prefix}${cls}`)

  return classes.join(' ')
}

// Generate mobile + desktop variants
function createFontSet() {
  const fontMap = { mobile: {}, desktop: {} }

  for (const [key, val] of Object.entries(fontTypes)) {
    fontMap.mobile[key] = createFont(
      val.fontSize,
      val.lineHeight,
      val.fontWeight,
      val.letterSpacing
    )

    fontMap.desktop[key] = createFont(
      val.fontSize,
      val.lineHeight,
      val.fontWeight,
      val.letterSpacing,
      true
    )
  }

  return fontMap
}

const fontNoMui = createFontSet()

export { fontNoMui, fontWeightToTailwind }
export default fontNoMui
